<template>
    <app-content-admin>
        <template slot="header">Add Template</template>

        <v-layout row wrap>
            <v-flex xs12 lg6 mx-auto>
                <v-card>
                    <v-card-text>
                        <v-container fluid grid-list-xs>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-select
                                        :items="project_list"
                                        :item-text="'project_name'"
                                        :item-value="'project_id'"
                                        :label="$t('Project')"
                                        v-model="form.id_project"
                                        :rules="[rules.required('Project')]"
                                        outlined
                                    ></v-select>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Template Title')"
                                        v-model="form.template_title"
                                        :rules="[
                                            rules.required('Template Title'),
                                        ]"
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <div class="textarea-wrap">
                                        <v-textarea
                                            :label="$t('Template Description')"
                                            v-model="form.template_description"
                                            outlined
                                            
                                        >
                                        </v-textarea>
                                        <span class="message-counter"
                                            >{{
                                                form.template_description.length
                                            }}
                                            </span
                                        >
                                    </div>
                                </v-flex>

                                <v-flex xs12>
                                    <v-select
                                        label="Notifcation Type"
                                        outlined
                                        item-value="key"
                                        item-text="value"
                                        :items="notification_type"
                                        v-model="form.notification_type"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Action URL')"
                                        v-model="form.action_url"
                                        :rules="[rules.required('Action URL')]"
                                        outlined
                                    >
                                    </v-text-field>
                                    <span class="h5"
                                        >eg.
                                        https://m.motherhood.com.my/product-detail/v-coool-summer-nursing-singlet-black
                                        (allow to put brand, seller, product and
                                        event url)</span
                                    >
                                </v-flex>

                                <v-radio-group
                                    row
                                    inline
                                    v-model="form.is_scheduled"
                                >
                                    <v-radio label="Yes" :value="1"></v-radio>
                                    <v-radio label="No" :value="0"></v-radio>
                                </v-radio-group>

                                <v-flex xs12 v-if="form.is_scheduled == 1">
                                    <v-text-field
                                        :label="$t('Select Schedule')"
                                        v-model="form.scheduled_at"
                                        ref="datepicker"
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>

                                <!-- <v-flex xs12>
                                    <v-file-input
                                        label="File input"
                                        outlined
                                        variant="outlined"
                                        :rules="[fileSizeRule, fileTypeRule]"
                                        v-model="file"
                                        @change="handleFileChange"
                                    ></v-file-input>
                                </v-flex> -->
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="createProject"
                            class="form-submit"
                        >
                            Submit
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from "../../components/status/ActiveLabel.vue";
import store from "@/store";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

window.$ = require("jquery");

export default {
    mixins: [vForm],

    data() {
        return {
            project_list: [],
            form: {
                id_project: null,
                template_title: null,
                template_description: "",
                notification_type: null,
                file_upload: null,
                action_url: null,
                is_scheduled: null,
                scheduled_at: null,
            },
            file: null,
            notification_type: [
                { key: "lastest_new", value: "Latest News" },
                { key: "event", value: "Event" },
                { key: "voucher", value: "Voucher" },
                { key: "promotion", value: "Promotion" },
                { key: "order", value: "Order" },
                { key: "tool", value: "Tool" },
                { key: "story", value: "Story" },
                { key: "video", value: "Video" },
            ],
            flatpickrInstance: null,
        };
    },

    components: { ActiveLabel },

    created() {
        let loader = this.$loading.show();

        let token = store.getters["auth/token"];
        axios
            .get(`/api/cloud/get_firebase_project_list?token=${token}`)
            .then((res) => res.data)
            .then((res) => {
                this.project_list = res.data.result.map((item) => {
                    return {
                        project_id: item.id_project,
                        project_name: item.firebase_project_name,
                    };
                });
            })
            .catch((err) => {
                this.$toastr.e(err.response.data.message);
            })
            .finally(() => {
                loader.hide();
            });
    },

    computed: {
        fileSizeRule() {
            return (value) => {
                if (!value) return true;

                const fileSize = value.size / 1024;
                const maxSize = 2048;

                return (
                    fileSize <= maxSize ||
                    `File size should be less than ${maxSize} KB`
                );
            };
        },
        fileTypeRule() {
            return (value) => {
                if (!value) return true;

                const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];

                return (
                    allowedTypes.includes(value.type) ||
                    "Only JPEG, JPG, and PNG files are allowed"
                );
            };
        },
    },

    updated() {
        if (this.$refs.datepicker && !this.flatpickrInstance) {
            this.initFlatpickr();
        }
    },

    methods: {
        initFlatpickr() {
            console.log(this.$refs.datepicker.$refs.input);
            this.flatpickrInstance = flatpickr(
                this.$refs.datepicker.$refs.input,
                {
                    enableTime: true,
                    dateFormat: "Y-m-d H:i",
                }
            );
        },
        async createProject() {
             if(this.is_scheduled == 0)
            {
                this.scheduled_at = null;
            }
            let loader = this.$loading.show();
            try {
                let token = store.getters["auth/token"];
                let res = await axios.post(
                    `/api/cloud/create_firebase_template?token=${token}`,
                    this.form
                );

                if (res.data.status == "success") {
                    this.$toastr.s(res.data.data.result);
                }
            } catch (err) {
                this.$toastr.e(err.response.data.message);
            } finally {
                loader.hide();
            }
        },

        async uploadFile() {
            const formData = new FormData();
            formData.append("file", this.file);
            let loader = this.$loading.show();
            try {
                let token = store.getters["auth/token"];
                let res = await axios.post(
                    `/api/cloud/upload_image?token=${token}`,
                    formData
                );

                if (res.data.status == "success") {
                    this.$toastr.s("Upload image Success!");
                    this.form.file_upload = res.data.data.fileName;
                }
            } catch (err) {
                this.$toastr.e("Upload image fail!");
            } finally {
                loader.hide();
            }
        },

        handleFileChange(file) {
            this.file = file;
            this.uploadFile();
        },

        fileChange(e) {
            this.form.firebase_service_account = e.name;
        },
    },
    watch: {
        // "form.scheduled_at": {
        //     handler: function (newVal) {
        //         var selectorEDD = document.getElementById("scheduled_at");
        //         Inputmask("datetime", {
        //             alias: "datetime",
        //             inputFormat: "yyyy-mm-dd HH:MM",
        //             outputFormat: "yyyy-mm-dd HH:MM",
        //             leapday: "29.02.",
        //         }).mask(selectorEDD);
        //     },
        // },
    },
};
</script>

<style>
.textarea-wrap {
    position: relative;
    max-width: 100%;
    margin: auto;
}

.message-counter {
    position: absolute;
    right: 5px;
    bottom: 36px;
    font-size: 13px;
    color: black;
}
</style>
